export const colors = {
  bg: {
    primary: 'bg-[var(--background)]',
    secondary: 'bg-[var(--surface)]',
    input: 'bg-white/70 dark:bg-slate-800/50',
    button: 'bg-blue-700 text-white dark:bg-blue-300 dark:text-slate-900',
  },
  text: {
    primary: 'text-[var(--foreground)]',
    secondary: 'text-[var(--muted)]',
    accent: 'text-[var(--accent)]',
  },
  border: {
    default: 'border-slate-300 dark:border-white/10',
    glow: 'border-[var(--accent-border)]',
  },
};
